var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fit layout-padding" }, [
    _c(
      "div",
      { staticClass: "row justify-center" },
      [
        _c(
          "q-list",
          {
            staticClass: "col-12 round",
            staticStyle: { padding: "0" },
            attrs: { sparse: true }
          },
          [
            _vm.$p(["ADMIN", "MANAGER", "AFFILIATE"], "or")
              ? _c(
                  "q-collapsible",
                  {
                    class: { error: _vm.validation.instructorForm.$invalid },
                    attrs: { group: "roles", separator: true }
                  },
                  [
                    _c(
                      "template",
                      { slot: "header" },
                      [
                        _c("q-item-main", [
                          _c(
                            "h5",
                            [
                              _c("q-icon", {
                                attrs: {
                                  color: "primary",
                                  name: "fa fa-graduation-cap"
                                }
                              }),
                              _vm._v(" Instructor")
                            ],
                            1
                          )
                        ]),
                        _c(
                          "q-item-side",
                          { attrs: { right: "" } },
                          [
                            _vm.validation.instructorForm.$invalid
                              ? _c("q-icon", {
                                  staticClass: "exclamation-circle-icon",
                                  attrs: { name: "fa fa-flag", color: "red" }
                                })
                              : _vm._e(),
                            _c("q-toggle", {
                              attrs: {
                                name: "Active",
                                "left-label": "",
                                size: "24px",
                                disable:
                                  !_vm.canEdit ||
                                  !_vm.$p(
                                    ["ADMIN", "MANAGER", "AFFILIATE"],
                                    "or"
                                  ),
                                label: _vm.activateLabel(
                                  _vm.instructorForm.ACTIVE_IND,
                                  _vm.instructorForm.INSTRUCTOR_ID
                                ),
                                "keep-color":
                                  _vm.activateLabel(
                                    _vm.instructorForm.ACTIVE_IND,
                                    _vm.instructorForm.INSTRUCTOR_ID
                                  ) == "Inactive"
                                    ? true
                                    : false,
                                color:
                                  _vm.activateLabel(
                                    _vm.instructorForm.ACTIVE_IND,
                                    _vm.instructorForm.INSTRUCTOR_ID
                                  ) == "Inactive"
                                    ? "red"
                                    : "green"
                              },
                              on: {
                                input: function($event) {
                                  _vm.updateInstructorForm({
                                    field: "ACTIVE_IND",
                                    value: _vm.instructorForm.ACTIVE_IND
                                  })
                                }
                              },
                              model: {
                                value: _vm.instructorForm.ACTIVE_IND,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.instructorForm,
                                    "ACTIVE_IND",
                                    $$v
                                  )
                                },
                                expression: "instructorForm.ACTIVE_IND"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c("user-details-instructor-form", {
                          attrs: { validation: _vm.validation }
                        })
                      ],
                      1
                    )
                  ],
                  2
                )
              : _vm._e(),
            _vm.$p(["ADMIN", "MANAGER", "RECRUITER"], "or") &&
            _vm.module !== "instructorApprovals"
              ? _c(
                  "q-collapsible",
                  {
                    class: { error: _vm.validation.affiliateForm.$invalid },
                    attrs: { group: "roles", separator: true }
                  },
                  [
                    _c(
                      "template",
                      { slot: "header" },
                      [
                        _c("q-item-main", [
                          _c(
                            "h5",
                            [
                              _c("q-icon", {
                                attrs: {
                                  color: "primary",
                                  name: "fa fa-building"
                                }
                              }),
                              _vm._v(" Affiliate")
                            ],
                            1
                          )
                        ]),
                        _c(
                          "q-item-side",
                          { attrs: { right: "" } },
                          [
                            _vm.validation.affiliateForm.$invalid ||
                            _vm.validation.affiliateForm.$invalid
                              ? _c("q-icon", {
                                  staticClass: "exclamation-circle-icon",
                                  attrs: { name: "fa fa-flag", color: "red" }
                                })
                              : _vm._e(),
                            _c("q-toggle", {
                              attrs: {
                                name: "Active",
                                label: _vm.activateLabel(
                                  _vm.affiliateForm.ACTIVE_IND,
                                  _vm.affiliateForm.AFFILIATE_ID
                                ),
                                "keep-color":
                                  _vm.activateLabel(
                                    _vm.affiliateForm.ACTIVE_IND,
                                    _vm.affiliateForm.AFFILIATE_ID
                                  ) == "Inactive"
                                    ? true
                                    : false,
                                color:
                                  _vm.activateLabel(
                                    _vm.affiliateForm.ACTIVE_IND,
                                    _vm.affiliateForm.AFFILIATE_ID
                                  ) == "Inactive"
                                    ? "red"
                                    : "green",
                                "left-label": "",
                                size: "24px",
                                disable:
                                  !_vm.canEdit ||
                                  !_vm.$p(["ADMIN", "MANAGER"], "or")
                              },
                              on: {
                                change: function($event) {
                                  _vm.updateAffiliateForm({
                                    field: "ACTIVE_IND",
                                    value: _vm.affiliateForm.ACTIVE_IND
                                  })
                                }
                              },
                              model: {
                                value: _vm.affiliateForm.ACTIVE_IND,
                                callback: function($$v) {
                                  _vm.$set(_vm.affiliateForm, "ACTIVE_IND", $$v)
                                },
                                expression: "affiliateForm.ACTIVE_IND"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c("user-details-affiliate-form", {
                          attrs: { validation: _vm.validation }
                        })
                      ],
                      1
                    )
                  ],
                  2
                )
              : _vm._e(),
            _vm.$p(["ADMIN", "MANAGER"], "or") &&
            _vm.module !== "instructorApprovals"
              ? _c(
                  "q-collapsible",
                  {
                    class: { error: _vm.validation.recruiterForm.$invalid },
                    attrs: { group: "roles", separator: true }
                  },
                  [
                    _c(
                      "template",
                      { slot: "header" },
                      [
                        _c("q-item-main", [
                          _c(
                            "h5",
                            [
                              _c("q-icon", {
                                attrs: {
                                  color: "primary",
                                  name: "fa fa-user-plus"
                                }
                              }),
                              _vm._v(" Recruiter")
                            ],
                            1
                          )
                        ]),
                        _c(
                          "q-item-side",
                          { attrs: { right: "" } },
                          [
                            _vm.validation.recruiterForm.$invalid
                              ? _c("q-icon", {
                                  staticClass: "exclamation-circle-icon",
                                  attrs: { name: "fa fa-flag", color: "red" }
                                })
                              : _vm._e(),
                            _c("q-toggle", {
                              attrs: {
                                name: "Active",
                                label: _vm.activateLabel(
                                  _vm.recruiterForm.ACTIVE_IND,
                                  _vm.recruiterForm.RECRUITER_ID
                                ),
                                "keep-color":
                                  _vm.activateLabel(
                                    _vm.recruiterForm.ACTIVE_IND,
                                    _vm.recruiterForm.RECRUITER_ID
                                  ) == "Inactive"
                                    ? true
                                    : false,
                                color:
                                  _vm.activateLabel(
                                    _vm.recruiterForm.ACTIVE_IND,
                                    _vm.recruiterForm.RECRUITER_ID
                                  ) == "Inactive"
                                    ? "red"
                                    : "green",
                                "left-label": "",
                                size: "24px",
                                disable:
                                  !_vm.canEdit ||
                                  !_vm.$p(["ADMIN", "MANAGER"], "or")
                              },
                              on: {
                                change: function($event) {
                                  _vm.updateRecruiterForm({
                                    field: "ACTIVE_IND",
                                    value: _vm.recruiterForm.ACTIVE_IND
                                  })
                                }
                              },
                              model: {
                                value: _vm.recruiterForm.ACTIVE_IND,
                                callback: function($$v) {
                                  _vm.$set(_vm.recruiterForm, "ACTIVE_IND", $$v)
                                },
                                expression: "recruiterForm.ACTIVE_IND"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c("user-details-recruiter-form", {
                          attrs: { validation: _vm.validation }
                        })
                      ],
                      1
                    )
                  ],
                  2
                )
              : _vm._e(),
            _vm.$p(["ADMIN"]) && _vm.module !== "instructorApprovals"
              ? _c(
                  "q-collapsible",
                  {
                    class: { error: _vm.validation.managerForm.$invalid },
                    attrs: { group: "roles", separator: true }
                  },
                  [
                    _c(
                      "template",
                      { slot: "header" },
                      [
                        _c("q-item-main", [
                          _c(
                            "h5",
                            [
                              _c("q-icon", {
                                attrs: { color: "primary", name: "fa fa-users" }
                              }),
                              _vm._v(" Manager")
                            ],
                            1
                          )
                        ]),
                        _c(
                          "q-item-side",
                          { attrs: { right: "" } },
                          [
                            _vm.validation.managerForm.$invalid
                              ? _c("q-icon", {
                                  staticClass: "exclamation-circle-icon",
                                  attrs: { name: "fa fa-flag", color: "red" }
                                })
                              : _vm._e(),
                            _c("q-toggle", {
                              attrs: {
                                name: "Active",
                                "left-label": "",
                                label: _vm.activateLabel(
                                  _vm.managerForm.ACTIVE_IND,
                                  _vm.managerForm.MANAGER_ID
                                ),
                                "keep-color":
                                  _vm.activateLabel(
                                    _vm.managerForm.ACTIVE_IND,
                                    _vm.managerForm.MANAGER_ID
                                  ) == "Inactive"
                                    ? true
                                    : false,
                                color:
                                  _vm.activateLabel(
                                    _vm.managerForm.ACTIVE_IND,
                                    _vm.managerForm.MANAGER_ID
                                  ) == "Inactive"
                                    ? "red"
                                    : "green",
                                size: "24px",
                                disable: !_vm.canEdit || !_vm.$p(["ADMIN"])
                              },
                              on: {
                                input: function($event) {
                                  _vm.updateManagerForm({
                                    field: "ACTIVE_IND",
                                    value: _vm.managerForm.ACTIVE_IND
                                  })
                                }
                              },
                              model: {
                                value: _vm.managerForm.ACTIVE_IND,
                                callback: function($$v) {
                                  _vm.$set(_vm.managerForm, "ACTIVE_IND", $$v)
                                },
                                expression: "managerForm.ACTIVE_IND"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c("user-details-manager-form", {
                          attrs: { validation: _vm.validation }
                        })
                      ],
                      1
                    )
                  ],
                  2
                )
              : _vm._e(),
            _vm.$p(["ADMIN"]) && _vm.module !== "instructorApprovals"
              ? _c(
                  "q-collapsible",
                  {
                    staticClass: "enabled-disabled",
                    class: { error: _vm.validation.administratorForm.$invalid },
                    attrs: { group: "roles", separator: true, disable: true }
                  },
                  [
                    _c(
                      "template",
                      { slot: "header" },
                      [
                        _c("q-item-main", [
                          _c(
                            "h5",
                            [
                              _c("q-icon", {
                                attrs: { color: "primary", name: "fa fa-magic" }
                              }),
                              _vm._v(" Administrator")
                            ],
                            1
                          )
                        ]),
                        _c(
                          "q-item-side",
                          { attrs: { right: "" } },
                          [
                            _vm.validation.administratorForm.$invalid
                              ? _c("q-icon", {
                                  staticClass: "exclamation-circle-icon",
                                  attrs: { name: "fa fa-flag", color: "red" }
                                })
                              : _vm._e(),
                            _c("q-toggle", {
                              attrs: {
                                name: "Active",
                                "left-label": "",
                                label: _vm.activateLabel(
                                  _vm.administratorForm.ACTIVE_IND,
                                  _vm.administratorForm.ADMINISTRATOR_ID
                                ),
                                "keep-color":
                                  _vm.activateLabel(
                                    _vm.administratorForm.ACTIVE_IND,
                                    _vm.administratorForm.ADMINISTRATOR_ID
                                  ) == "Inactive"
                                    ? true
                                    : false,
                                color:
                                  _vm.activateLabel(
                                    _vm.administratorForm.ACTIVE_IND,
                                    _vm.administratorForm.ADMINISTRATOR_ID
                                  ) == "Inactive"
                                    ? "red"
                                    : "green",
                                size: "24px",
                                disable: !_vm.canEdit || !_vm.$p(["ADMIN"])
                              },
                              on: {
                                change: function($event) {
                                  _vm.updateAdministratorForm({
                                    field: "ACTIVE_IND",
                                    value: _vm.administratorForm.ACTIVE_IND
                                  })
                                }
                              },
                              model: {
                                value: _vm.administratorForm.ACTIVE_IND,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.administratorForm,
                                    "ACTIVE_IND",
                                    $$v
                                  )
                                },
                                expression: "administratorForm.ACTIVE_IND"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c("user-details-administrator-form", {
                          attrs: { validation: _vm.validation }
                        })
                      ],
                      1
                    )
                  ],
                  2
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }